<template>
    <page
        :busy="busy"
        :tabs="tabsToRender"
        class="i-calendar-page"
    >
        <grid
            ref="grid"
            :columnDefs="columnDefs"
            :fetchCallback="fetchCallback"
            :is-auto-width="true"
            :headerHeight="45"
        >
            <div class="toolbar">
                <responsive-button
                    title="Refresh Table"
                    variant="primary"
                    :icon="['fas', 'arrows-rotate']"
                    @click="refresh"
                    >Refresh
                </responsive-button>
            </div>
            </grid
    ></page>
</template>

<script>
import { ICALENDAR_SYNC_LOGS_GRID_ENDPOINT } from '../../endpoints';
import Grid from '../generic/grid/grid.vue';
import ResponsiveButton from '../generic/responsive-button/responsive-button.vue';
import Modal from '../generic/modal/modal.vue';
import Page from '../generic/page/page.vue';
import API from '../../api';
import { isMobileScreen } from '../../utils/screens';

export default {
    components: {
        Grid,
        ResponsiveButton,
        Modal,
        Page,
    },
    data() {
        return {
            tabsToRender: [
                {
                    id: 'icalendar-urls',
                    title: 'ICalendar Setup',
                    active: false,
                    route: '/app/icalendar/urls',
                },
                {
                    id: 'icalendar-logs',
                    title: 'Logs',
                    active: true,
                    route: '/app/icalendar/logs',
                },
            ],
            offset: 0,
            limit: 20,
            sort: 'created',
            desc: false,
            search: '',
            columnDefs: [
                {
                    field: 'id',
                    hide: true,
                },
                {
                    field: 'created',
                    headerName: 'Timestamp',
                    type: 'dateTimeColumn',
                    sort: 'desc',
                },
                {
                    field: 'rental_property.name',
                    headerName: 'Property',
                },
                {
                    field: 'icalendar.url',
                    headerName: 'iCal URL',
                    minWidth: 200,
                    autoWidthExclude: true,
                },
                {
                    field: 'import_from_date',
                    headerName: 'Import From Date',
                    type: 'dateColumn',
                },
                {
                    field: 'import_to_date',
                    headerName: 'Import To Date',
                    type: 'dateColumn',
                },
                {
                    field: 'conflict_from_date',
                    headerName: 'Conflict From Date',
                    type: 'dateColumn',
                },
                {
                    field: 'conflict_to_date',
                    headerName: 'Conflict To Date',
                    type: 'dateColumn',
                },
                {
                    field: 'line',
                    headerName: 'Message',
                    minWidth: 250,
                },
                {
                    field: '',
                    headerName: '',
                    autoWidthExclude: true,
                    sortable: false,
                    minWidth: 100,
                    hide: !isMobileScreen(),
                },
            ],
            busy: false,
        };
    },
    computed: {
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return API.get(ICALENDAR_SYNC_LOGS_GRID_ENDPOINT(), {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                    },
                });
            };
        },
    },
    methods: {
        refresh() {
            this.$refs.grid.refreshDataSource();
        },
    },
};
</script>
